import { Injectable } from '@angular/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { ApiService } from './api.service'; // Import the ApiService

@Injectable({
  providedIn: 'root'
})
export class LocalNotificationService {

  constructor(
    private apiService: ApiService // Inject the ApiService
  ) { }

  async checkNotificationPermission(): Promise<boolean> {
    const status = await LocalNotifications.requestPermissions();
    console.log(status);
    return (status as any).notifications === 'granted' || status.display === 'granted';
  }

  private createReminderNotification(appointmentId: number, title: string, startTime: Date, minutesOffset: number): any {
    // Utility to capitalize the first letter of a string
    const capitalizeFirstLetter = (string) => {
        if (!string) return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    // Format the start time
    const hours = startTime.getHours().toString().padStart(2, '0');
    const minutes = startTime.getMinutes().toString().padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;

    // Schedule the notification minutesOffset earlier
    const reminderTime = new Date(startTime.getTime() - minutesOffset * 60 * 1000);

    // Adjust the message based on the offset
    const bodyMessage =
        minutesOffset === 0
            ? 'Starts now'
            : `Starts at ${formattedTime} (in ${minutesOffset} minutes)`;


    // Generate a unique ID for the notification
    const uniqueId = appointmentId * 1000 + minutesOffset;

    return {
        title: capitalizeFirstLetter(title),
        body: bodyMessage,
        id: uniqueId, // Unique ID using appointmentId and minutesOffset
        schedule: { at: reminderTime },
        sound: "ding.mp3",
        attachments: null, // Fixed to align with expected null format
        actionTypeId: "",
        extra: null
    };

            //icon: 'assets/notification-icon.png', // Path to your custom icon
        //badge: 'assets/notification-badge.png', // Path to badge icon
  //       actions: [
  //   { id: 'view', title: 'View Details' },
  //   { id: 'dismiss', title: 'Dismiss' }
  // ]
  }

  async scheduleNotifications(appointments: any[]) {
    console.log('scheduleNotifications');
    
    // Check if the user has granted notification permissions
    const hasPermission = await this.checkNotificationPermission();
    if (!hasPermission) {
      console.log('Notification permission not granted');
      return;
    }

    let notifications = [];

    appointments.forEach((appointment) => {

      // Notification for every reminder in the appointment
      // For each of the numbers in reminders property appointment.reminders e.g. [0, 5, 15, 30] schedule if it's not within the delay time
      
      appointment.reminders.forEach((reminder) => {
        // If we are within the delay time of the appointment, we will not schedule this notification
        if (new Date(appointment.startTime).getTime() - new Date().getTime() > reminder * 60 * 1000) {
          const reminderNotification = this.createReminderNotification(
            appointment.id,
            appointment.title,
            new Date(appointment.startTime),
            reminder
          );
          notifications.push(reminderNotification);
        }
      });

    });

    console.log('Scheduling notifications');
    console.log(notifications);

    await LocalNotifications.schedule({ notifications });
  }

  async refreshNotifications() {
    // Hide notifications that are pending
    await LocalNotifications.removeAllDeliveredNotifications();

    console.log('Delivered notifications cleared');

    // Cancel existing local notifications
    await this.cancelAllNotifications();

    console.log('Pending notifications cleared');

    // Dates
    // We do not want a reference to the date otherwise we will change the selected date
    var dateToCalculate = new Date();

    // Start from the current moment, no need to adjust to the start of the day
    const startDate = dateToCalculate.toISOString();

    // Calculate the end date 2 months ahead from now
    dateToCalculate.setMonth(dateToCalculate.getMonth() + 2);

    // No need to adjust the time to the end of the day here if you want the exact 2-month period from now
    const endDate = dateToCalculate.toISOString();

    this.apiService.getRemindersByRange(startDate, endDate).subscribe(appointments => {
        if (appointments && appointments.length) {
          console.log('Scheduling notifications ['+appointments.length+']')
          this.scheduleNotifications(appointments);
        }
    });
    
  }

  async cancelAllNotifications() {
    // Fetch all pending notifications
    const { notifications } = await LocalNotifications.getPending();
    
    if (notifications.length) {
        // Extract the IDs from the pending notifications
        const ids = notifications.map(notification => notification.id);
        
        // Map IDs to the format expected by the cancel method
        const cancellationDescriptors = ids.map(id => ({ id }));
        
        // Cancel the pending notifications
        await LocalNotifications.cancel({ notifications: cancellationDescriptors });
    }
  }

  // Other methods remain unchanged...
}